// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"Collapse_collapsed__3gfac","show":"Collapse_show__QiT4d","collapsing":"Collapse_collapsing__32RpQ"};